import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Error from '../error/Error';
import * as classes from './Input.module.scss';

import classNames from 'classnames';

const Input = forwardRef(
  ({ id, name, value, onChange, type = 'text', label, error, placeholder, variant, prefix, ...props }, ref) => (
    <div>
      {label && (
        <label htmlFor={id} className={classes.inputLabel}>
          {label}
        </label>
      )}

      <div
        className={classNames({
          [classes.inputWrapper]: true,
          [classes[`variant__${variant}`]]: variant
        })}
      >
        {prefix && <span className={classes.inputPrefix}>{prefix}</span>}

        <input
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={classes.input}
          type={type}
          ref={ref}
          {...props}
        />
      </div>

      {error && <Error>{error?.message}</Error>}
    </div>
  )
);
Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  label: PropTypes.node,
  error: PropTypes.object,
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf([null, 'overdraftCalculator'])
};

export default Input;
